import React from 'react';

const Image = ({ block }) => {
  if (!block) return null;

  return (
    <section className={`block__image block ${block.css_class_name}`}>
      {block.image && (
        <div className='container'>
          <img
            className='card-image'
            src={block.image}
            alt={block.image_alt_text}
            title={block.image_alt_text}
          />
        </div>
      )}
    </section>
  );
};

export default Image;
